import get from 'lodash/get'
import React from 'react'
import Helmet from 'react-helmet'
import { siteMetadata } from '../../../gatsby-config'
import { navigateTo } from 'gatsby-link'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

String.prototype.replaceAll = function(search, replacement) {
  var target = this
  return target.replace(new RegExp(search, 'g'), replacement)
}

class PredlozhitStih extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value.replaceAll('\\n', '&#13;&#10;'),
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form.getAttribute('name'),
        ...this.state,
      }),
    })
      .then(() => navigateTo(form.getAttribute('action')))
      .catch(error => alert(error))
  }

  render() {
    const pathPrefix =
      process.env.NODE_ENV === 'development' ? '' : __PATH_PREFIX__
    const title = 'Предложить стих'
    return (
      <div>
        <Helmet
          title={`${title} | ${get(siteMetadata, 'title')}`}
          meta={[
            { property: 'og:title', content: title },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: get(siteMetadata, 'description'),
            },
            {
              property: 'og:url',
              content: `${get(siteMetadata, 'url')}/predlozhit-stih`,
            },
            {
              property: 'vk:image',
              content: `${get(siteMetadata, 'url')}/img/vkimage.jpg`,
            },
            {
              property: 'og:image',
              content: `${get(siteMetadata, 'url')}/img/cover.jpg`,
            },
          ]}
        />
        <section className="text-center">
          <div className="container">
            <h1>Предложить стих</h1>
            <p className="lead text-muted">
              Здесь вы можете предложить свой духовный стих, и мы его добавим
              его на сайт. <br /> Спаси Христос!
            </p>
          </div>
          <form
            name="new stih"
            id="newStih"
            method="post"
            action="/spasi-hristos"
            data-netlify="true"
            data-netlify-honeypot="no-field"
            className="container"
            onSubmit={this.handleSubmit}
          >
            <input type="hidden" name="no-field" onChange={this.handleChange} />
            <div className="form-group">
              <input
                type="text"
                name="name"
                onChange={this.handleChange}
                className="form-control form-control-lg"
                placeholder="Название стиха"
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group">
              <textarea
                className="form-control form-control-lg"
                name="stih-text"
                placeholder="Духовный стих"
                rows="10"
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group">
              <textarea
                className="form-control form-control-lg"
                name="comment"
                placeholder="Здесь можно написать комментарий (например, историю стиха, имя
                  автора и т.д.)"
                rows="3"
                onChange={this.handleChange}
              />
            </div>
            {/* <div data-netlify-recaptcha /> */}
            <button type="submit" className="btn btn-primary btn-lg">
              Отправить
            </button>
          </form>
        </section>
      </div>
    )
  }
}

export default PredlozhitStih



// WEBPACK FOOTER //
// ./src/pages/predlozhit-stih/index.jsx